declare global {
  interface Window {
    extended: {
      VITE_API_BASE_URL: string;
      VITE_STRIPE_PUBLIC_KEY: string;
      VITE_STRIPE_AGENCY_PLAN_PRODUCT_ID: string;
      VITE_STRIPE_AGENCY_SEAT_PRODUCT_ID: string;
      [key: string]: string;
    };
    gtag: (...args: any[]) => void;
  }
}

// Helper function to get config value based on environment
const getConfigValue = (envVar: string, windowVar: string | undefined, defaultValue: string = '') => {
  const isDev = import.meta.env.MODE === 'development';
  const envValue = import.meta.env[envVar];

  // In development, use environment variables
  if (isDev) {
    return envValue || defaultValue;
  }

  // In production, use window.extended values
  if (!window.extended && typeof window !== 'undefined') {
    console.warn('window.extended not available, using default value for', envVar);
    return defaultValue;
  }

  return windowVar || defaultValue;
};

// Function to reload config when window.extended becomes available
export const reloadConfig = () => {
  if (import.meta.env.MODE === 'development') return;

  // Wait for window.extended to be available
  const checkExtended = () => {
    if (window.extended) {
      console.log('window.extended is now available, reloading config...');
      // Force a page reload to get the correct config
      window.location.reload();
    } else {
      setTimeout(checkExtended, 100);
    }
  };

  if (!window.extended) {
    console.log('window.extended not available, waiting...');
    checkExtended();
  }
};

export const config = {
  apiUrl: getConfigValue('VITE_API_BASE_URL', window.extended?.VITE_API_BASE_URL, 'http://localhost:3000/api'),
  stripe: {
    publicKey: getConfigValue('VITE_STRIPE_PUBLIC_KEY', window.extended?.VITE_STRIPE_PUBLIC_KEY),
    agencyPlanProductId: getConfigValue('VITE_STRIPE_AGENCY_PLAN_PRODUCT_ID', window.extended?.VITE_STRIPE_AGENCY_PLAN_PRODUCT_ID),
    agencySeatProductId: getConfigValue('VITE_STRIPE_AGENCY_SEAT_PRODUCT_ID', window.extended?.VITE_STRIPE_AGENCY_SEAT_PRODUCT_ID)
  }
};

// If we're using the default API URL in production, try to reload config
if (import.meta.env.MODE !== 'development' && config.apiUrl === 'http://localhost:3000/api' && !window.extended) {
  console.warn('Using default API URL in production, attempting to reload config...');
  reloadConfig();
}

// Backward compatibility - expose stripePublicKey for components that use it
export const stripePublicKey = config.stripe.publicKey;

export default config; 
